const PUBLIC_INVITE_PATHS = new Set([
  '/invite/welcome',
]);


/**
 * 친구가 처음 들어오는 혜택 안내만 공개한다.
 * 초대자의 링크·통계가 있는 /invite 대시보드는 계속 로그인으로 보호한다.
 */
export const isPublicInvitePath = (pathname) => (
  PUBLIC_INVITE_PATHS.has(pathname)
);
